import styled from 'styled-components';

const WordWrapDiv = styled.div`
  word-wrap: break-word;
`;

export default WordWrapDiv;
